import { render } from "./OrderCreate.vue?vue&type=template&id=65b19a53&scoped=true"
import script from "./OrderCreate.vue?vue&type=script&lang=js"
export * from "./OrderCreate.vue?vue&type=script&lang=js"

import "./OrderCreate.vue?vue&type=style&index=0&id=65b19a53&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b19a53"]])

export default __exports__